export function sendContact(data) {
  return {
    type: '@contact/sendContact',
    payload: {data}
  };
}